// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__1-t8T","tab":"styles_tab__15hVi","tab_on":"styles_tab_on__cY67p"};